/**
 * Plot wave runners (docs/opencadstudio-parity/02-plot-pdf-ctb.md tasks
 * 2.7/2.8/2.9): PLOT opens the real PDF plot dialog, PAGESETUP manages the
 * per-layout named page setup, PUBLISH batch-plots the selected layouts
 * into one multi-page PDF. Registered LAST in the runner barrel so these
 * supersede the BIM sheet bridge and the removed window.print path.
 */

import type { RunnerMap } from '../runnerRegistry';
import { useAppStore } from '../../../state/store';
import { useLayoutStore } from '../../../state/useLayoutStore';
import { openPlotDialog, openPageSetupDialog } from '../../../services/plot/plotDialogBridge';

export const plotRunners: RunnerMap = {
    // PLOT: real vector PDF through the plot dialog (K3).
    'file.plot': (args) => {
        const mode = (args?.[0] ?? '').toLowerCase() === 'publish' ? 'publish' : 'single';
        const store = useLayoutStore.getState();
        openPlotDialog({ mode, layoutId: store.activeId });
        return mode === 'publish'
            ? 'PUBLISH: layout selection dialog opened.'
            : 'PLOT: plot dialog opened (vector PDF output).';
    },

    // PAGESETUP: named page setup of the current layout (O2's PAGESETUP half).
    'file.pageSetup': (args) => {
        const store = useLayoutStore.getState();
        let layoutId = store.activeId;
        if (args && args.length > 0) {
            const name = args.join(' ').trim();
            const hit = store.layouts.find((l) => l.name.toLowerCase() === name.toLowerCase());
            if (hit) layoutId = hit.id;
        }
        openPageSetupDialog({ layoutId });
        return 'PAGESETUP: page setup dialog opened.';
    },

    // PUBLISH: selected layouts → one PDF, each with its own setup (K3).
    'file.publish': () => {
        openPlotDialog({ mode: 'publish' });
        return 'PUBLISH: layout batch dialog opened.';
    },

    // SHEETSET (Faz 10.13): toggle the Sheet Set Manager palette.
    'file.sheetSet': () => {
        const app = useAppStore.getState();
        app.toggleSheetSetPalette();
        return `SHEETSET: Sheet Set Manager palette ${app.sheetSetOpen ? 'closed' : 'opened'}.`;
    },
};
